import React from 'react';
import { Message } from 'barnyard/components';
import PropTypes from 'prop-types';

const NoPermissionMessage = (props) => {
  const { hasPermission, className } = props;

  if (hasPermission) {
    return null;
  }

  return (
    <Message
      color='warning'
      border={true}
      className={className}
      message='Your account does not have permission to modify these fields. Please contact your account admin or the Vetcove team for assistance if you believe you should have access.'
    />
  );
};

NoPermissionMessage.propTypes = {
  hasPermission: PropTypes.bool.isRequired,
  className: PropTypes.string,
};

export default NoPermissionMessage;
